// ATTENTION: This has to be a pure list of strings, otherwise it can't be consumed by
// copyRedirects.ts. So unfortunately you cannot import e.g. OptioPayRoutes and define
// OPTIOPAY: OptioPayRoutes.ROOT. (If you know a fix for that -> be my guest).

export const FeatureRoutes = {
    PIN_RESET: "/pin-reset",
    APPOINTMENT: "/appointment",
    SHOP: "/shop",
    SHOP_CREDIT_CARD: "/shop-credit-card",
    SHOP_CREDIT_CARD_BUSINESS: "/shop-credit-card-business",
    SHOP_BANK_CARD: "/shop-bank-card",
    SHOP_SAVINGS: "/shop-savings",
    CREDIT_CARD_UPGRADE: "/cc-upgrade",
    CONSUMER_LOAN: "/consumer-loan",
    DEFERRAL_SERVICE: "/deferral-service",
    STORE: "/store",
    OPTIOPAY: "/optiopay",
    OPTIOPAY_ACTIVATION: "/optiopay-activation",
    CHANGE_REPAYMENT: "/change-repayment",
    QUICK_DRAWDAWN: "/quick-drawdown",
    GEO_CONTROL: "/geo-control",
    REISSUE_CARD: "/reissue-card",
    REISSUE_CARD_UPGRADE: "/reissue-card-upgrade",
    ACTIVATE_CARD: "/activate-card",
    LINK_ACCOUNT: "/link-account",
    SIDENTITY: "/sidentity",
    SIDENTITY_SETTINGS: "/sidentitysettings",
    GID_SETTINGS: "/gid",
    TPP: "/tpp",
    GIG: "/gig",
    ACCIDENT_INSURANCE: "/accident-insurance",
    PENSION_INSURANCE: "/pension-insurance",
    LIFE_INSURANCE: "/life-insurance",
    PENSION_FUNDS: "/pension-funds",
    CAR_LEASING: "/car-leasing",
    SHOW_CARD_DATA: "/show-card-data",
    FIT: "/fit",
    LOYALTY: "/cc-loyalty",
    USERMANAGEMENT: "/usermanagement",
    SURVEY: "/survey",
    APP_STORE_REDIRECT_DEPRECATED: "/georgeapp-backup",
    APP_STORE_REDIRECT: "/georgeapp",
    APP_STORE_REDIRECT_CAMPAIGN: "/georgeapp-campaign",
    LOGIN_MANAGEMENT: "/login-management",
    GOOGLE_PAY: "/googlepay",
    POCKETS: "/pockets",
    BSP_OPTIONS: "/BSP-options",
    BSP_OPTIONS_PAYOUT: "/BSP-option-Payout",
    ASSET_CALCULATION: "/asset-calculation",
    ICH_APP: "/ichapp/settings",
    TEAMCARD_LINKAGE: "/teamcard-linkage",
    JUNIOR: "/junior",
    TRADING_PREFERENCES: "/trading-preferences",
    HOUSEHOLD_INSURANCE: "/household-insurance",
    HANDOVER_URL_TEST: "/handover-url-test",
    SAVINGS_OPTIONS: "/savings-options",
    APP_BUSINESS_STORE_REDIRECT: "/george-business-app",
};

export const ErrorRoutes = {
    NO_TOKEN: "/notoken",
    UNAUTHORIZED: "/unauthorized",
    FORBIDDEN: "/forbidden",
    ERROR: "/error",
    ERROR_MESSAGE: "/error/:messageId"
};



// WEBPACK FOOTER //
// ./src/components/app/AppRoutes.ts